import tippy from 'tippy.js';
import type { Attachment } from 'svelte/attachments';

// our usual data-tippy attribute is read once on DOMContentLoaded;
// for dynamic content in Svelte use this helper
export function tippyTooltip(content: string): Attachment {
  return (element: Element) => {
    const popover = element.closest('[popover]');
    const appendTo = popover || document.body;

    const instance = tippy(element as HTMLElement, {
      content,
      appendTo,
    });
    return () => instance.destroy();
  };
}
